<template>
  <div class="m-task shop-mission shop-view">
    <!-- /.skin-show -->
    <div class="top-skin-view">
        <div class="pic"><img src="https://web-resource.17m3.com/m3guo/202106/adshop/images/icon/R.png" alt="" srcset=""></div>
        <div class="skin-detail">
            <p>R技能-护驾！</p>
            <p>全图秒杀有手就行</p>
            <div class="u-btn skin" @click="$skin_modal()"></div>
        </div>
    </div>

    <div class="main-task">
      <div class="task-detail" v-if="ready">
          <h6>封灵玉*阿斗赶集</h6>
          <p>阿斗赶集历史付费共 <em class="icon-m3b"></em><span>88888</span> <span class="pro">( {{ taskinfo.totalPay || 0 }}/88888 )</span> </p>    
          <div class="u-btn apply act" id="main-task" v-if="taskinfo['totalPayDraw']['88888'] == 0 && taskinfo.totalPay >= 88888" @click="applyTask('totalPayDraw',88888)" v-bind:data-type="'totalPayDraw'" v-bind:data-index="88888">可领取</div>
          <div class="u-btn disabled" v-if="taskinfo['totalPayDraw']['88888'] == 0 && taskinfo.totalPay < 88888">不可领取</div>
          <div class="u-btn dismiss" v-if="taskinfo['totalPayDraw']['88888'] == 1">已领取</div>
      </div>      
    </div>

    <div class="task-header"></div>
    <div class="task-view">
        <div class="task-wrapper">
          <div class="task-panel" v-if="ready">
              <ul class="task-list" v-for="(item,name) in task" :key="name">
                  <li v-for="(_task,index) in item.detailList" :key="index">
                      <p>{{ item.title_1 }} <em>{{ _task.max }}</em><span v-html="item.title_3"></span></p>
                      <p>{{ item.title_2 }} <span class="task-cnt">({{ taskinfo[item.key] || 0 }}/{{ _task.max }})</span></p>
                      <ul class="reward-list">
                          <li v-for="(reward,number) in _task.rewardlist" :key="number">
                              <div class="pic" v-if="$store.state.tipsimg.indexOf(reward) > -1" @click="$item_tips({ item_id : reward + '.png',type : 'img'})">
                                <!-- <img v-bind:src="'https://web-resource.17m3.com/m3guo/202109/adshop/images/icon/'+ reward +'.jpg'"> -->
                                <div class="reward-pic"><game-item :id="reward" :num="_task.rewardnum[number]" :locked="true"></game-item></div>
                              </div>
                              <div class="pic" v-else @click="$item_tips({ item_id : reward })" >
                                <!-- <img v-bind:src="'https://web-resource.17m3.com/m3guo/202203/adshop/icon/'+ reward +'.jpg'"> -->
                                <div class="reward-pic"><game-item :id="reward" :num="_task.rewardnum[number]" :locked="true"></game-item></div>
                              </div>
                          </li>
                      </ul>
                      <div class="task-status" v-if="taskinfo[name]">
                          <div class="u-btn apply act" v-if="taskinfo[name][_task.max] == 0 && taskinfo[item.key] >= _task.max" @click="applyTask(name,_task.max)" v-bind:data-type="name" v-bind:data-index="_task.max">可领取</div>
                          <div class="u-btn disabled" v-if="taskinfo[name][_task.max] == 0 && taskinfo[item.key] < _task.max">不可领取</div>
                          <div class="u-btn dismiss" v-if="taskinfo[name][_task.max] == 1">已领取</div>
                      </div>
                      <div class="task-status" v-else>
                          <div class="u-btn disabled">不可领取</div>
                      </div>                    
                  </li>
              </ul>
          </div>            
        </div>
    </div>
    <div class="task-footer"></div>

    <recommend></recommend>

    <div class="bottom-bubble">
        <div class="txt-bubble"></div>
        <div class="u-btn u-top"></div>
    </div>  

  </div>
</template>

<script>
import recommend from '@/components/recommend.vue'

export default {
  components : {
    'recommend' : recommend,
  },    
  data (){
    return {
      ready : false,
      ua: () => {},
      taskinfo: () => {},
      task: {
          currentBuyDraw: {
              key: 'currentBuy',
              title_1: '本次阿斗赶集购买',
              title_2: '可获得',
              title_3: '件商品',
              detailList: [{
                  max: 2,
                  rewardlist: ['X622'],
                  rewardnum : [1],
              }, {
                  max: 4,
                  rewardlist: ['MH92'],
                  rewardnum : [1],
              }, {
                  max: 6,
                  rewardlist: ['X918'],
                  rewardnum : [1],
              }, {
                  max: 8,
                  rewardlist: ['X630'],
                  rewardnum : [3],
              }, {
                  max: 10,
                  rewardlist: ['K749'],
                  rewardnum : [5],
              }, {
                  max: 14,
                  rewardlist: ['MD48'],
                  rewardnum : [50],
              }, {
                  max: 18,
                  rewardlist: ['Y821'],
                  rewardnum : [2],
              }, {
                  max: 25,
                  rewardlist: ['LF85'],
                  rewardnum : [20],
              }]
          },
          totalJoinDraw: {
              key: 'totalJoin',
              title_1: '参与阿斗赶集共',
              title_2: '可获得',
              title_3: '期',
              detailList: [{
                  max: 1,
                  rewardlist: ['HG82'],
                  rewardnum : [1],
              }, {
                  max: 3,
                  rewardlist: ['Y634'],
                  rewardnum : [1],
              }, {
                  max: 5,
                  rewardlist: ['D774'],
                  rewardnum : [2],
              }, {
                  max: 8,
                  rewardlist: ['F280'],
                  rewardnum : [2],
              }, {
                  max: 11,
                  rewardlist: ['ZK19'],
                  rewardnum : [1],
              }, {
                  max: 15,
                  rewardlist: ['Y657'],
                  rewardnum : [3],
              }]
          },
          totalPayDraw: {
              key: 'totalPay',
              title_1: '阿斗赶集历史累计消费达',
              title_2: '可获得',
              title_3: '<em class="icon-m3b"></em>',
              detailList: [{
                  max: 10000,
                  rewardlist: ['E900'],
                  rewardnum : [1],
              }, {
                  max: 30000,
                  rewardlist: ['Y658'],
                  rewardnum : [5],
              }, {
                  max: 88888,
                  rewardlist: ['FN84'],
                  rewardnum : [1],
              }, {
                  max: 138888,
                  rewardlist: ['KL25'],
                  rewardnum : [1],
              }, {
                  max: 198888,
                  rewardlist: ['KT26'],
                  rewardnum : [10],
              },{
                max : 298888,
                rewardlist: ['LF52'],
                rewardnum : [1],
              },
              {
                max : 458888,
                rewardlist: ['MB34'],
                rewardnum : [1],
              }]
          },
      }      
    }
  },
  created (){

    if(!parseInt(this.$store.state.login)){
      this.$router.push('/')
      return this.$mslogin.open();
    }
    if(!this.$store.state.userinfo){
      this.$router.push('/')
      return this.$toast('请先选择大区');
    }


    this.render();
    //this.userinfo = this.$store.state.userinfo || {}    
  },
  methods : {
    render (){
      this.$axios.get(this.$ajax_url_map.task)
      .then(res => {
        this.ready = true;
        this.taskinfo = res.data;
      },rej => {

      })
    },
    applyTask (type,index){
      var _this = this;
      this.$axios.post(this.$ajax_url_map.getfuli,this.$qs.stringify({
        type: type,
        index: index       
      }))
      .then(res => {
        this.$toast('领取成功~')
        _this.taskinfo[type][index] = 1;
      },rej => {
        this.$toast(rej.message);
      })
    },
  },
}
</script>

<style scoped>
/* mission */
.shop-mission {
    position: relative;
    padding-top: 480px;
    background-image: url(~@/assets/images/body-mission.jpg);
    background-color: #341e0d;
    background-size: 750px auto;
    background-position: top center;
    background-repeat: no-repeat;
}

.shop-mission .top-skin-view {
    position: absolute;
    left: 35px;
    top: 318px;
    width: 380px;
    height: 152px;
    background-image: url(~@/assets/images/view-fuli-top.png);
}

.top-skin-view .pic {
    position: absolute;
    top: 23px;
    left: 33px;
    width: 100px;
    height: 100px;
}

.top-skin-view .pic img {
    position: relative;
    left: 50%;
    top: 50%;
    width: 70px;
    height: 70px;
    transform: translate(-50%, -50%);
}

.skin-detail {
    padding: 15px 0 0 155px;
}

.skin-detail p {
    font-size: 24px;
    color: #dcc4b1;
}

.skin-detail .u-btn.skin {
    width: 161px;
    height: 52px;
    margin-top: 5px;
    background-image: url(~@/assets/images/btn-detail.png);
}

.main-task {
    position: relative;
    width: 711px;
    height: 150px;
    margin: 0 auto;
    background-image: url(~@/assets/images/bg-mission-main.png);
}

.main-task .task-detail {
    padding: 20px 0 0 30px;
}

.main-task .task-detail h6 {
    margin-bottom: 15px;
    font-size: 28px;
    font-weight: 700;
    color: #683d1e;
}

.main-task .task-detail p {
    color: #683d1e;
}

.main-task .task-detail .pro {
    color: #ad7239;
}

.main-task .task-detail .u-btn {
    font-size: 0;
    color: transparent;
}

.main-task .task-detail .u-btn.apply {
    position: absolute;
    top: 20px;
    right: 35px;
    width: 100px;
    height: 100px;
    background-image: url(~@/assets/images/btn-mission-apply-main.png);
}

.main-task .task-detail .u-btn.dismiss {
    position: absolute;
    top: 20px;
    right: 35px;
    width: 101px;
    height: 111px;
    background-image: url(~@/assets/images/icon-status-get.png);
    filter: none;
}

.main-task .task-detail .u-btn.disabled {
    position: absolute;
    top: 20px;
    right: 35px;
    width: 100px;
    height: 100px;
    background-image: url(~@/assets/images/btn-mission-apply-main-disabled.png);
    filter: none;
}

.task-header {
    position: relative;
    width: 750px;
    height: 145px;
    margin: -50px auto 0;
    background-image: url(~@/assets/images/bg-mission-top.png);
    pointer-events: none;
}

.task-view {
    margin-top: -1px;
    background: url(~@/assets/images/bg-mission-body.png) center top repeat-y;
    background-size: auto 50px;
}

.task-footer {
    width: 750px;
    height: 156px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/images/bg-mission-bottom.png);
}

.task-wrapper {
    padding: 0 20px;
}

.task-panel ul.task-list {
    margin: 0 60px 12px;
    padding: 8px 12px 20px;
    background-color: rgba(66, 38, 17, .8);
    border: 1px solid #613719;
    border-radius: 25px;
}

.task-panel ul.task-list:last-child {
    margin-bottom: 0;
}

.task-panel ul.task-list>li {
    position: relative;
    margin-top: 12px;
    padding-left: 18px;
    padding-bottom: 20px;
    border-bottom: 1px solid #613719;
}

.task-panel ul.task-list>li:last-child {
    border-bottom: none;
}

.task-panel p {
    color: #dcc4b1;
}

.task-panel p em {
    color: #d3a061;
}

.task-panel .task-cnt {
    color: #d3a061;
}

.task-panel .reward-list {
    display: flex;
}

.task-panel .pic {
    position: relative;
    width: 113px;
    height: 112px;
    margin-top: 15px;
    margin-right: 17px;
    background-image: url(~@/assets/images/bg-item_2.png);
}

.task-panel .pic .reward-pic {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 70px;
    height: 70px;
    transform: translate(-50%, -50%);
}

.task-panel .task-status {
    position: absolute;
    top: 50px;
    right: 35px;
    color: transparent;
    font-size: 0;
}

.task-status .u-btn.dismiss {
    width: 101px;
    height: 111px;
    background-image: url(~@/assets/images/icon-status-get.png);
    filter: none;
}

.task-status .u-btn.disabled {
    width: 100px;
    height: 100px;
    background-image: url(~@/assets/images/btn-mission-apply-disabled.png);
    filter: none;
}

.task-status .u-btn {
    width: 100px;
    height: 100px;
    background-image: url(~@/assets/images/btn-mission-apply.png);
}
</style>



// WEBPACK FOOTER //
// src/views/task.vue